module.exports = __webpack_public_path__ + "static/media/logo-grajau.7ec02703.png";